// extracted by mini-css-extract-plugin
export default {"video":"video_video__IlBZI"};